import { Modal, ModalDialog, ModalOverflow, ModalClose, Typography, Stack, Box, Button } from "@mui/joy";
import { useContext } from "react";
import { LayoutContext } from "../../context";
import { motion, AnimatePresence } from "framer-motion";

const STEPS = [
    {
        img: './help_ios/ios_notif_1.jpg', // скрин поиска в настройках
        title: 'Шаг 1. Откройте Настройки',
        desc: 'Закройте приложение. Откройте «Настройки» телефона и найдите через поиск «PLANIUM».',
    },
    {
        img: './help_ios/ios_notif_2.jpg', // скрин страницы приложения
        title: 'Шаг 2. Откройте приложение',
        desc: 'Нажмите на «PLANIUM» в результатах поиска.',
    },
    {
        img: './help_ios/ios_notif_3.jpg', // скрин раздела Уведомления - Выкл
        title: 'Шаг 3. Уведомления',
        desc: 'Нажмите на пункт «Уведомления».',
    },
    {
        img: './help_ios/ios_notif_4.jpg', // скрин с тоглом Допуск уведомлений
        title: 'Шаг 4. Включите допуск',
        desc: 'Включите «Допуск уведомлений» — переключатель станет зелёным.',
    },
];

export default function ModalIOSNotifHelp() {
    const { modalIOSNotifHelp, setModalIOSNotifHelp } = useContext(LayoutContext);

    return (
        <AnimatePresence>
            {modalIOSNotifHelp && (
                <Modal
                    open={modalIOSNotifHelp}
                    onClose={() => setModalIOSNotifHelp(false)}
                    sx={{ zIndex: 10020 }}
                    slotProps={{
                        backdrop: {
                            component: motion.div,
                            initial: { opacity: 0 },
                            animate: { opacity: 1 },
                            exit: { opacity: 0 },
                        }
                    }}
                >
                    <ModalOverflow>
                        <ModalDialog
                            component={motion.div}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: 20 }}
                            sx={{ width: '95vw', maxWidth: 420, p: 3, borderRadius: 'xl' }}
                        >
                            <ModalClose />
                            
                            <Typography level="h4" fontWeight={700} sx={{ mb: 2, textAlign: 'center' }}>
                                🔔 Как включить уведомления
                            </Typography>

                            <Stack spacing={3}>
                                {STEPS.map((step, i) => (
                                    <Box key={i}>
                                        <Typography level="title-sm" fontWeight={700} sx={{ mb: 0.5 }}>
                                            {step.title}
                                        </Typography>
                                        <Typography level="body-sm" sx={{ color: 'text.secondary', mb: 1 }}>
                                            {step.desc}
                                        </Typography>
                                        <Box
                                            component="img"
                                            src={step.img}
                                            sx={{
                                                width: '100%',
                                                borderRadius: 'lg',
                                                border: '1px solid',
                                                borderColor: 'divider',
                                            }}
                                        />
                                    </Box>
                                ))}
                            </Stack>

                            <Button
                                sx={{ mt: 3, borderRadius: 'lg' }}
                                onClick={() => setModalIOSNotifHelp(false)}
                            >
                                Понятно, спасибо!
                            </Button>
                        </ModalDialog>
                    </ModalOverflow>
                </Modal>
            )}
        </AnimatePresence>
    );
}